import { useRouter } from "next/router";
import ReactMarkdown from "react-markdown";
import { getButtonAppearance } from "utils/button";

import ButtonLink from "../elements/button-link";
import NextImage from "../elements/image";

import styles from "@/styles/app-block.module.scss";

const AppBlock = ({ data }) => {
  const textPosition =
    data.textStyle === "Left"
      ? "text-left"
      : data.textStyle === "Center"
      ? "text-center"
      : false;
  const router = useRouter();
  const isCreditCard = router.asPath === "/credit-card";
  const isCurrentAccount = router.asPath === "/debit-account";
  return (
    <section
      className={`md:pt-36 ${
        !textPosition
          ? styles.altBg
          : isCreditCard
          ? `md:pt-20 ${styles.bgCreditCard}`
          : styles.bg
      }`}
    >
      <div
        className={`grid max-w-1424 mx-auto grid-cols-1 md:grid-cols-12 pt-0 ${textPosition} md:text-left `}
      >
        <div
          className={`flex px-7 md:py-0 flex-col gap-12 md:gap-12 col-span-1  ${
            !textPosition
              ? "md:col-span-6 md:col-start-8 py-10 md:px-20"
              : "md:col-span-7 py-16 md:py-16 md:px-24"
          } ${
            isCurrentAccount
              ? "justify-center"
              : isCreditCard
              ? "md:px-40 bg-onmoLightGrey md:bg-transparent"
              : ""
          }`}
        >
          <div className="flex flex-col gap-4">
            {data.smallTitle === null ? null : (
              <h5 className={styles.smallTitle}>{data.smallTitle}</h5>
            )}
            {data.textStyle === "Top" ? (
              <h1
                className={`hidden md:block ${styles.titleUpdated}`}
                dangerouslySetInnerHTML={{ __html: data.title }}
              />
            ) : (
              <h1
                className={styles.titleUpdated}
                dangerouslySetInnerHTML={{ __html: data.title }}
              />
            )}
            {/* <p className={styles.descriptionUpdated}>{data.description}</p> */}
            <ReactMarkdown className={styles.descriptionUpdated}>
              {data.description}
            </ReactMarkdown>
          </div>
          {data.button ? (
            <ButtonLink
              updated
              size={data.button.size}
              button={data.button}
              appearance={getButtonAppearance(data.button.type)}
            />
          ) : null}
        </div>
        <div
          className={`relative  h-full w-full col-span-1 order-first md:${
            data.textStyle === "Top" ? "order-first" : "order-last"
          } md:col-span-5 py-20 md:py-0 ${
            data.textStyle === "Top" ? "py-0" : styles.bgMobile
          }`}
        >
          <div
            className={`hidden md:flex ${
              !textPosition
                ? "justify-center mb-10 md:mb-7 mx-auto max-w-[232px]"
                : "justify-start max-w-[340px]"
            }`}
          >
            <NextImage
              media={data.appImage.data[0]}
              width={data.appImage.data[0].attributes.width}
              height={data.appImage.data[0].attributes.height}
            />
          </div>
          {data.textStyle === "Top" ? (
            <h1
              className={`block md:hidden text-center mb-14 md:mb-10 mx-auto max-w-[350px] ${styles.titleUpdated}`}
              dangerouslySetInnerHTML={{ __html: data.title }}
            />
          ) : null}
          <div className="flex md:hidden justify-center my-5 md:my-0 max-w-[233px] mx-auto">
            {data.appImage.data[1] === undefined ? (
              <NextImage
                media={data.appImage.data[0]}
                width={data.appImage.data[0].attributes.width}
                height={data.appImage.data[0].attributes.height}
              />
            ) : (
              <NextImage
                media={data.appImage.data[1]}
                width={data.appImage.data[1].attributes.width}
                height={data.appImage.data[1].attributes.height}
              />
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AppBlock;
